import { ChipArrayField } from 'admin/fields/ChipArrayField';
import { RoleInput } from 'admin/inputs/RoleInput';
import { UserInput } from 'admin/inputs/UserInput';
import { SERVICE_AREA_TYPES } from 'admin/userRelations/userRelationUtils';
import { USER_ROLES } from 'admin/users/userUtils';
import { AuthContext } from 'common/providers/AuthContextProvider/AuthContextProvider';
import { Role, useCurrentUserQuery } from 'generated/graphql';
import { useContext } from 'react';
import { ArrayField, ChipField, Datagrid, DateField, List, SingleFieldList, TextField } from 'react-admin';

export const StaffList: React.FC = () => {
  const { isAuthenticated } = useContext(AuthContext);
  const { data } = useCurrentUserQuery({ skip: !isAuthenticated });

  const hasAnyRole = (allowedRoles: Role[]) =>
    isAuthenticated && data?.user?.roles?.some((role: Role) => allowedRoles.includes(role));

  const filteredRoles = [Role.RoleFinancialAdvisor];
  if (hasAnyRole([Role.RoleAdmin])) {
    filteredRoles.push(Role.RoleScout, Role.RoleAdmin);
  }

  const filters = [
    <UserInput label="E-mail" roles={filteredRoles} source="user.id" />,
    <RoleInput label="Rola" source="user.roles.role" />,
  ];

  return (
    <List exporter={false} filters={filters} sort={{ field: 'creationTimestamp', order: 'DESC' }}>
      <Datagrid bulkActionButtons={false} rowClick="show">
        <TextField label="ID" source="id" />
        <TextField label="Meno" source="user.name" />
        <TextField label="Priezvisko" source="user.surname" />
        <TextField label="E-mail" source="user.email" />
        <TextField label="Tel." source="user.phoneNumber" />
        <ChipArrayField choices={USER_ROLES} label="Role" sortable={false} source="user.roles" />
        <ArrayField label="Mestá pôsobenia" sort={{ field: 'name', order: 'ASC' }} source="serviceLocations">
          <SingleFieldList linkType={false}>
            <ChipField source="name" />
          </SingleFieldList>
        </ArrayField>
        <ChipArrayField choices={SERVICE_AREA_TYPES} label="Licencie" sortable={false} source="serviceAreas" />
        <DateField label="Dátum vytvorenia" locales="sk" source="creationTimestamp" />
        <DateField label="Dátum zmeny" locales="sk" source="updateTimestamp" />
      </Datagrid>
    </List>
  );
};
